import { getDateGivenOffset } from '@/utilities/dates'

const defaultAdvancedDateSelection = {
  dates: {
    value: '3',
    startDateOffset: -7,
    endDateOffset: 0,
    startDate: getDateGivenOffset(new Date(), -7),
    endDate: getDateGivenOffset(new Date(), 0),
  },
}

const defaultSingleDateSelection = () => {
  return new Date().toISOString().slice(0, 10)
}

export const mergeFieldsSelections = (baseFields, savedSelections) => {
  const updatedFields = baseFields.map(item => {
    let [saved] = savedSelections.filter(setting => setting.id === item.id)
    if (saved === undefined) {
      saved = {}
    }
    let settingSelection = saved ? saved.selection : []
    if (item.isDate && !item.showFixedOptions) {
      settingSelection =
        saved.selection === ''
          ? defaultSingleDateSelection()
          : {
              dates: {
                startDate: settingSelection.dates?.startDate
                  ? settingSelection.dates.startDate
                  : settingSelection,
                endDate: settingSelection.dates?.endDate
                  ? settingSelection.dates.endDate
                  : settingSelection,
              },
            }
    }
    if (item.isDate && item.showFixedOptions) {
      settingSelection =
        saved && saved.selection !== ''
          ? settingSelection
          : defaultAdvancedDateSelection
    }
    const settingSelectedItems = saved ? saved.selectedItems : []
    let settingVisible = true
    if (saved && saved.visible !== undefined) {
      settingVisible = saved.visible
    }
    const lockedItems = saved.lockedItems || []
    const tabDisabled = saved.tabDisabled || false
    const selectorDisabled = saved.selectorDisabled || false

    return {
      ...item,
      lockedItems,
      selection: settingSelection,
      selectedItems: settingSelectedItems,
      selectorDisabled,
      tabDisabled,
      visible: settingVisible,
    }
  })

  return updatedFields
}
